
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useEffect } from "react";

const UndoToaster = ({onUndoAction, title = 'Task updated', icon = ''}) => {
    useEffect(() => {
        document.removeEventListener('keydown', undoAction);
        document.addEventListener('keydown', undoAction);

        return () => {
            document.removeEventListener('keydown', undoAction);
        }
    }, []);
    
    const undoAction = (e) => {
        if ((e.ctrlKey == true || e.metaKey) && (e.key == 'z' || e.keyCode == 26)) {
          document.removeEventListener('keydown', undoAction);
          onUndoAction();
        }
    }

    return <div className="task-delete-popup bottom-conformation-popup fixed dark:border dark:border-white">
        <div className="task-undo">
            <button className="delete leftWrap" type="button" css={{
                svg: {
                    path: {
                        stroke: 'white !important'
                    }
                }
            }}>
                {icon} <span className="task-delete">{title}</span>
            </button>
            <button className="undo" type="button" onClick={onUndoAction}>
                <span className="task-archive">Undo</span>
            </button>
        </div>
    </div>
}

export default UndoToaster;